'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('bulletin-edit', {
      url: '/bulletin/edit/:id',
      template: '<bulletin-edit></bulletin-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/bulletin/edit/bulletin-edit.routes.js